import { RenderIf } from 'components/desktop/_general/Conditional/RenderIf';
import * as Item from 'components/desktop/_general/ItemListEditor/Item';
import ListItem from 'components/desktop/_general/ListItem/ListItem';
import * as Tree from 'types/_general/Tree/Tree';
import * as TreeList from 'types/_general/Tree/TreeList';

interface IProps {
	all: Tree.Type[];
	selected: Tree.Type[];
	removeFromSelected: (input: Tree.Type) => void;
	readOnly?: boolean;
}

const SelectedItems = (props: IProps) => {
	return (
		<RenderIf condition={Boolean(props.selected.length)}>
			<div className="overflow-auto mt-2" data-component-type="treeview-selected-items">
				{props.selected.map((item: Tree.Type, i: number) => (
					<ListItem
						key={i}
						text={item.name}
						title={TreeList.getCategoryString(props.all, item)}
						handleDelete={
							props.readOnly ? undefined : () => props.removeFromSelected(item)
						}
						textColor={Item.getColorFromLogic(item)}
					/>
				))}
			</div>
		</RenderIf>
	);
};

export default SelectedItems;
